module.exports = __webpack_public_path__ + "static/media/myCalc.9d839fb5.png";